import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";
import { cn } from "@helpers/general";

import { InventoryPolicies } from "@constants/InventoryPolicies";
import { Country } from "@constants/Country";

function RadioVariants({ variant, handleOnChangeSize, product, countryCode }) {
  const isInventoryPolicyContinue = variant?.inventoryPolicy === InventoryPolicies.CONTINUE;
  let isVariantDisable = variant?.availableForSale === false;

  if (variant?.availableForSale && isInventoryPolicyContinue && countryCode !== Country.US) {
    isVariantDisable = true;
  }

  return (
    <div
      className={`${cn(
        "m-0 border border-dark-grey rounded-[4px] min-w-[32px] min-h-[32px] flex justify-center items-center hover:bg-black hover:text-white cursor-pointer",
        isVariantDisable &&
          "bg-[#ededed] text-[#757575] border-0 cursor-not-allowed relative after:content-[''] after:absolute after:left-0 after:top-1/2 after:-translate-y-px after:w-full after:h-px after:bg-current after:rotate-45 hover:bg-unset hover:text-[#757575]"
      )}`}
    >
      <input
        className="hidden"
        onChange={() => {
          handleOnChangeSize(variant);
        }}
        type="radio"
        name={`${variant.selectedOptions[0].name}-${product.id}`}
        value={variant.title}
        disabled={isVariantDisable}
        id={`${variant.selectedOptions[0].name}-${variant.title}-${product.id}`}
      />
      <label
        className="typo-body font-bold flex items-center justify-center h-full w-full"
        htmlFor={`${variant.selectedOptions[0].name}-${variant.title}-${product.id}`}
      >
        {variant.title}
      </label>
    </div>
  );
}

export default withALErrorBoundary({
  name: "RadioVariants",
  priority: "P1",
})(RadioVariants);
